import api from "./api";
import { BillingSetting, BillingSettingImportResult } from "../models/BillingSetting";
import { ApiResult } from "../models/ExchangeNumerary";

const base = "/api/billing-settings";

export const getBillingSettings = async (): Promise<BillingSetting[]> => (await api.get(base)).data;

export const getBillingSetting = async (id: string): Promise<BillingSetting> => (await api.get(`${base}/${id}`)).data;

export const saveBillingSetting = async (setting: BillingSetting): Promise<ApiResult> =>
  (setting.id ? await api.put(`${base}/${setting.id}`, setting) : await api.post(base, setting)).data;

export const linkBillingSettingClient = async (id: string, commercialClientId: string | null): Promise<ApiResult> =>
  (await api.put(`${base}/${id}/client`, { commercialClientId })).data;

export const deleteBillingSetting = async (id: string): Promise<ApiResult> => (await api.delete(`${base}/${id}`)).data;

export const importGettBillingSettings = async (file: File): Promise<BillingSettingImportResult> => {
  const form = new FormData();
  form.append("file", file);
  return (await api.post(`${base}/import-gett`, form)).data;
};
